import React from 'react'

export default function Customers() {
    const token = JSON.parse(localStorage.getItem('selectedOrg')).token 
  return (
<iframe src={process.env.REACT_APP_IFRAME_ENDPOINT+"/customers/#/overview?orgToken="+token} height={'100%'} width={'100%'}></iframe>
  )
}
